(function () {
  let resizeIframe = () => {
    iFrameResize(
      {
        heightCalculationMethod: 'lowestElement',
        onResized: function (message) {
          if (message.type !== 'init') {
            return;
          }

          $('html, body').animate({
            scrollTop: $('.js--iframe-resize').offset().top - 40,
          });
        },
      },
      '.js--iframe-resize'
    );
  };

  document.addEventListener('shopify:section:load', function () {
    resizeIframe();
  });

  resizeIframe();
})();
